import { Component, ElementRef, OnInit } from '@angular/core'
import { Meta } from '@angular/platform-browser'
import { AuthService } from '@app/services'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {
    title = 'Hello all!'

    constructor(private meta: Meta, private elemRef: ElementRef, private auth: AuthService) {
        meta.addTag({ name: 'description', content: 'Title and Meta tags examples' })
        meta.addTag({
            name: 'viewport',
            content: 'width=device-width, initial-scale=1,maximum-scale=1.0, user-scalable=no',
        })
        meta.addTag({ name: 'HandheldFriendly', content: 'true' })
    }

    ngOnInit() {
        this.elemRef.nativeElement.addEventListener('gesturestart', (event) => {
            event.preventDefault()
            event.body.style.zoom = 0.99
        })
        this.elemRef.nativeElement.addEventListener('gesturechange', (event) => {
            event.preventDefault()
            event.body.style.zoom = 0.99
        })
        this.elemRef.nativeElement.addEventListener('gestureend', (event) => {
            event.preventDefault()
            event.body.style.zoom = 0.99
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts